import { render, staticRenderFns } from "./ColaboradoresView.vue?vue&type=template&id=3ed1ca7d&scoped=true"
import script from "./ColaboradoresView.vue?vue&type=script&lang=js"
export * from "./ColaboradoresView.vue?vue&type=script&lang=js"
import style0 from "./ColaboradoresView.vue?vue&type=style&index=0&id=3ed1ca7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1ca7d",
  null
  
)

export default component.exports